import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsInt, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { MarketOperator, MarketType, PaymentMethod } from "../../../entities/market.entity";
import MarketOrderStatus from "../../../entities/market-status.entity";

export default class CreateMarketResource {
    @IsString()
    @Expose({ name: 'condominium_id' })
    readonly condominium: string;

    @IsString()
    @IsOptional()
    @Expose({ name: 'contractor_id' })
    readonly contractor?: string;

    @IsBoolean()
    @IsOptional()
    @Expose({ name: 'is_sync_enable'})
    readonly isSyncEnable?: boolean;

    @IsString()
    readonly label: string;

    @IsString()
    @IsOptional()
    @Expose({ name: 'market_code'})
    readonly marketCode?: string;

    @IsEnum(MarketOperator)
    readonly operator: MarketOperator;

    @IsArray()
    @IsOptional()
    @Expose({ name: 'payment_methods'})
    readonly paymentMethods?: PaymentMethod[];

    @IsNumber()
    @IsOptional()
    @Expose({ name: 'prestashop_address_id' })
    readonly prestashopAddressId?: number;

    @IsString()
    @IsOptional()
    @Expose({ name: 'prestashop_auth_token' })
    readonly prestashopAuthToken?: string;

    @IsString()
    @IsOptional()
    @Expose({ name: 'prestashop_base_url' })
    readonly prestashopBaseUrl?: string;

    @IsNumber()
    @IsOptional()
    @Expose({ name: 'prestashop_carrier_id' })
    readonly prestashopCarrierId?: number;

    @IsNumber()
    @IsOptional()
    @Expose({ name: 'prestashop_category_parent_id' })
    readonly prestashopCategoryParentId?: number;

    @IsNumber()
    @IsOptional()
    @Expose({ name: 'prestashop_currency_id' })
    readonly prestashopCurrencyId?: number;

    @IsNumber()
    @IsOptional()
    @Expose({ name: 'prestashop_group_shop_id' })
    readonly prestashopGroupShopId?: number;

    @IsNumber()
    @IsOptional()
    @Expose({ name: 'prestashop_lang_id' })
    readonly prestashopLangId?: number;

    @IsString()
    @IsOptional()
    @Expose({ name: 'prestashop_module_id' })
    readonly prestashopModuleId?: string;

    @IsNumber()
    @IsOptional()
    @Expose({ name: 'prestashop_shop_id' })
    readonly prestashopShopId?: number;

    @IsEnum(MarketType)
    readonly type: MarketType;

    @IsOptional()
    @ValidateNested()
    @Type(() => MarketOrderStatus)
    @Expose({ name: 'prestashop_order_status' })
    readonly prestashopOrderStatus?: MarketOrderStatus;

    constructor(init?: CreateMarketResource) {
      this.condominium = init?.condominium!;
      this.contractor = init?.contractor;
      this.isSyncEnable = init?.isSyncEnable;
      this.label = init?.label!;
      this.marketCode = init?.marketCode;
      this.operator = init?.operator!;
      this.paymentMethods = init?.paymentMethods;
      this.prestashopAddressId = init?.prestashopAddressId;
      this.prestashopAuthToken = init?.prestashopAuthToken;
      this.prestashopBaseUrl = init?.prestashopBaseUrl;
      this.prestashopCarrierId = init?.prestashopCarrierId;
      this.prestashopCategoryParentId = init?.prestashopCategoryParentId;
      this.prestashopCurrencyId = init?.prestashopCurrencyId;
      this.prestashopGroupShopId = init?.prestashopGroupShopId;
      this.prestashopLangId = init?.prestashopLangId;
      this.prestashopModuleId = init?.prestashopModuleId;
      this.prestashopShopId = init?.prestashopShopId;
      this.type = init?.type!;
      this.prestashopOrderStatus = init?.prestashopOrderStatus;
    }
}
